import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export default function Spinner({ noStyle, size }) {
  const antIcon = <LoadingOutlined style={{ fontSize: size || 24 }} spin />;
  return (
    <div
      style={
        noStyle
          ? {}
          : {
              display: "flex",
              justifyContent: "center",
              width: "100%",
              marginTop: "3rem",
            }
      }
    >
      <Spin indicator={antIcon} />
    </div>
  );
}
